import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type NotificationSeverity = 'success' | 'error' | 'warning' | 'info';
export type NotificationVariant = 'default' | 'professional';

export interface NotificationAction {
  label: string;
  href: string;
}

export interface Notification {
  id: string;
  title?: string;
  message: string;
  severity: NotificationSeverity;
  variant?: NotificationVariant;
  persistent?: boolean;
  action?: NotificationAction;
  senderName?: string;
}

interface NotificationsState {
  queue: Notification[];
}

const initialState: NotificationsState = {
  queue: [],
};

export const notificationsSlice = createSlice({
  name: 'notifications',
  initialState,
  reducers: {
    pushNotification: (state, action: PayloadAction<Omit<Notification, 'id'>>) => {
      state.queue.push({
        ...action.payload,
        id: `${Date.now()}-${Math.random()}`,
      });
    },
    dismissNotification: (state, action: PayloadAction<string>) => {
      state.queue = state.queue.filter((n) => n.id !== action.payload);
    },
  },
});

export const { pushNotification, dismissNotification } = notificationsSlice.actions;

export default notificationsSlice.reducer;
